import React from "react";
import EmailTemplatesContainer from "../../modules/OrganizationEmailTemplates/containers/EmailTemplatesContainer/EmailTemplatesContainer";

const EmailTemplates = () => {
  return <EmailTemplatesContainer />;
};

export default EmailTemplates;
